// extracted by mini-css-extract-plugin
export default {"list":"StepperVertical_list__MaWy3","item":"StepperVertical_item__O1TmS","active":"StepperVertical_active__KFQEi","done":"StepperVertical_done__Qg+XZ"};